/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Light_Sandy_Mouse_GazeInputs */

const en_light_sandy_mouse_gaze = /** @type {(inputs: Light_Sandy_Mouse_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All comments`)
};

const de_light_sandy_mouse_gaze = /** @type {(inputs: Light_Sandy_Mouse_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Kommentare`)
};

/**
* | output |
* | --- |
* | "All comments" |
*
* @param {Light_Sandy_Mouse_GazeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const light_sandy_mouse_gaze = /** @type {((inputs?: Light_Sandy_Mouse_GazeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Light_Sandy_Mouse_GazeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_light_sandy_mouse_gaze(inputs)
	return de_light_sandy_mouse_gaze(inputs)
});